<template>
  <div class="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
        <img class="w-auto h-20 mx-auto mt-1" src="@/assets/hp/kairo-logo-v2.png" alt="Kairo">
        <h2 class="text-gray-700 font-medium text-center mb-6">Confirming your email</h2>

        <div v-if="authToken || confirmationStatus === 'verifying'" class="inline-flex text-base leading-6 font-medium rounded-md text-green-600 cursor-not-allowed">
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ confirmationMessage || 'Verifying your email...' }}
        </div>

        <div v-else-if="confirmationStatus === 'success'" class="rounded-md bg-green-50 p-4 text-green-800 text-sm">
          {{ confirmationMessage || 'Your email has been verified. Redirecting...' }}
        </div>

        <div v-else-if="confirmationStatus === 'error'" class="rounded-md bg-red-50 p-4 text-red-800 text-sm">
          {{ confirmationMessage || 'Unable to verify your email right now.' }}
        </div>

        <div v-else class="rounded-md bg-gray-50 p-4 text-gray-700 text-sm">
          <div class="inline-flex items-center text-base leading-6 font-medium text-gray-600 cursor-not-allowed">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Waiting for confirmation token...
          </div>
        </div>

        <div class="mt-6 text-sm text-gray-500">
          <router-link to="/login" class="font-medium text-indigo-600 hover:text-indigo-500">
            Go to login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const EMAIL_CONFIRMATION_STATUS_KEY = 'kairo_email_confirmation_status';

function readEmailConfirmationStatus() {
  try {
    const raw = window.sessionStorage.getItem(EMAIL_CONFIRMATION_STATUS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error('Unable to read email confirmation status.', error);
    return null;
  }
}

export default {
  name: 'ConfirmEmail',
  data() {
    return {
      confirmationStatus: null,
      confirmationMessage: '',
    };
  },
  computed: {
    ...mapGetters('auth', ['authToken']),
  },
  methods: {
    applyStatus(status) {
      if (!status?.status) {
        return;
      }

      this.confirmationStatus = status.status;
      this.confirmationMessage = status.message || '';
    },
    handleConfirmationEvent(event) {
      this.applyStatus(event.detail);
    },
  },
  mounted() {
    window.addEventListener('kairo:email-confirmation', this.handleConfirmationEvent);
    this.applyStatus(readEmailConfirmationStatus());
  },
  beforeUnmount() {
    window.removeEventListener('kairo:email-confirmation', this.handleConfirmationEvent);
  },
};
</script>